<div class="modal-header">
  <h2>{{ userToEdit ? "Edit user" : "Create new user" }}</h2>
  <button type="button" aria-label="Close" (click)="closeModal.emit(true)">
    ×
  </button>
</div>

<div class="modal-body">
  <form *ngIf="userForm" [formGroup]="userForm">
    <div class="wrapper">
      <label for="name">Name</label>
      <input
        type="text"
        [class.border-red-500]="submitted && userForm.get('name')?.invalid"
        formControlName="name"
        id="name"
      />
    </div>

    <div class="wrapper">
      <label for="email">Email</label>
      <input
        type="text"
        [class.border-red-500]="submitted && userForm.get('email')?.invalid"
        formControlName="email"
        id="email"
      />
    </div>

    <div class="wrapper">
      <label for="role_id">Role ID</label>
      <ng-select formControlName="role_id" bindValue="id" [items]="roles"
                 [class.border-red-500]="submitted && userForm.get('role_id')?.invalid">
        <ng-template ng-label-tmp let-item="item">{{
            item.id + " - " + item.name
          }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
            item.id + " - " + item.name
          }}</ng-template>
      </ng-select>
    </div>

    <div class="wrapper" *ngIf="isInstallerRole">
      <label for="subcalendar_id">TeamUp Installer</label>
      <ng-select formControlName="subcalendar_id" bindValue="id" [items]="installers"
                 [class.border-red-500]="submitted && userForm.get('subcalendar_id')?.invalid">
        <ng-template ng-label-tmp let-item="item">{{
            item.id + " - " + item.description
          }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
            item.id + " - " + item.description
          }}</ng-template>
      </ng-select>
    </div>

    <div class="wrapper" *ngIf="isDesignerRole">
      <label for="zoho_contact_owner_id">Design Consultant (Zoho)</label>
      <ng-select formControlName="zoho_contact_owner_id" bindValue="id" [items]="zohoOwners"
                 [class.border-red-500]="submitted && userForm.get('zoho_contact_owner_id')?.invalid"
                 [class.border-slate-200]="!userForm.get('zoho_contact_owner_id')?.invalid"
                 class="h-[42px] border rounded-lg w-full text-black">
        <ng-template ng-label-tmp let-item="item">{{
            item.description
          }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
            item.description
          }}</ng-template>
      </ng-select>
    </div>

    <div class="wrapper" *ngIf="isDesignerRole">
      <label for="teamup_job_owner_id">Job Owner (TeamUp)</label>
      <ng-select formControlName="teamup_job_owner_id" bindValue="id" [items]="teamUpWho"
                 [class.border-red-500]="submitted && userForm.get('teamup_job_owner_id')?.invalid"
                 [class.border-slate-200]="!userForm.get('teamup_job_owner_id')?.invalid"
                 class="h-[42px] border rounded-lg w-full text-black">
        <ng-template ng-label-tmp let-item="item">{{
            item.description
          }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
            item.description
          }}</ng-template>
      </ng-select>
    </div>

    <div class="wrapper">
      <label for="password">Password</label>
      <input
        type="password"
        [class.border-red-500]="submitted && userForm.get('password')?.invalid"
        formControlName="password"
        id="password"
      />
    </div>

    <div class="wrapper">
      <label for="confirm_password">Confirm Password</label>
      <input
        type="password"
        [class.border-red-500]="submitted && (userForm.get('confirm_password')?.invalid || userForm.hasError('passwordMismatch'))"
        formControlName="confirm_password"
        id="confirm_password"
      />
    </div>

    <div class="wrapper">
      <label for="phone">Phone</label>
      <input
        type="text"
        [class.border-red-500]="submitted && userForm.get('phone')?.invalid"
        formControlName="phone"
        id="phone"
      />
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button"
          class="btn btn--outline"
          (click)="closeModal.emit(true)">
    Cancel
  </button>

  <button type="submit"
          class="btn btn--accent"
          (click)="userToEdit ? updateUser() : createUser()">
    Save
  </button>
</div>
